// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {get_config} from './select_config';
import {Select} from './select';
import {url2md5} from 'pub_config';
// @ts-ignore
import {list, get_country_object, www2code} from '/util/country.js';

const countries = Object.keys(list).map(key=>{
    const {name, code} = get_country_object(key);
    return {value: code, label: name};
});

interface i_country_select_props {
    label?: React.ReactNode;
    placeholder?: React.ReactNode;
    default_value?: string;
    no_body_label?: boolean;
    cls?: string;
    ignore_empty_flag_countries?: boolean;
    drop_down_icon?: JSX.Element;
    with_full_search?: boolean;
    full_search_placeholder?: string;
    disabled?: boolean;
    position?: 'right' | 'left';
    on_change?: (value: string | null)=>void;
    on_open?: ()=>void;
    on_close?: ()=>void;
}

export const Country_select = (props: i_country_select_props)=>{
    const {
        on_change,
        on_open,
        on_close,
        label = 'Country',
        default_value,
        placeholder = 'Select country',
        drop_down_icon,
        with_full_search,
        full_search_placeholder = 'Search country name',
        disabled,
        cls,
        position,
        no_body_label,
    } = props;
    const country_options = props.ignore_empty_flag_countries ?
        countries.filter(country=>!get_config()
            .country_no_flag.has(country.value)) : countries;
    const render_option = ({option, selected, ignore_label = false})=>{
        const iso_code = www2code(option.value);
        const src = url2md5(
            `${get_config().country_flags_url}${iso_code}.svg`);
        const flag_img = get_config().country_no_flag.has(option.value) ?
          <span/> : <img src={src} data-elem="flag_img"/>;
        return <>
          {flag_img}
          {!ignore_label && option.label}
          {selected && <span data-elem="selected_icon">
            {get_config().selected_icon}</span>}
        </>;
    };
    const render_body = ({selected, value})=>{
        let text = placeholder;
        if (selected && value)
        {
            const option = countries.find(opt=>opt.value === value) || {};
            text = render_option({
                option,
                selected: false,
                ignore_label: no_body_label,
            });
        }
        return <>
          {text}
          <span data-elem="dropdown_icon">{drop_down_icon
            || get_config().dropdown_icon}</span>
        </>;
    };
    return <Select
      cls={cls}
      on_open={on_open}
      default_value={default_value}
      label={label}
      disabled={disabled}
      on_change={(value: string | null)=>on_change(www2code(value))}
      on_close={on_close}
      placeholder={<>Select country</>}
      options={country_options}
      render_option={render_option}
      render_body={render_body}
      position={position}
      with_full_search={with_full_search}
      full_search_placeholder={full_search_placeholder}
      search_mode="starts_with"
    />;
};
